import React, { useState, useContext, useEffect, useRef } from "react";
import {
  Label,
  Input,
  Form,
  Row,
  TabPane,
  Col,
  FormGroup,
  Button,
  Modal,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import { Formik, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import apiClient from "../../../api/courier/axiosInstanceCourier";
import { AuthContext } from "../../ExtraPages/AuthProvider";
import { getCourierByUserId } from "../../../api/courier/courierApi";
import { Cropper } from "react-cropper";
import "cropperjs/dist/cropper.css";
import Swal from "sweetalert2";

import { getPlantByUserId } from "../../../api/processing plant/plantApi";
import ProcessingPlantGallery from "./ProcessingPlantGallery"; // Adjust the import path as necessary
import boat1 from "../../../assets/images/stock_details/boat_1.png";
import ImageCropModal4 from "./ImageCropModal4";
import WorkingDaysWidget from "./WorkingDaysWidget";
const CourierForm = ({ onPercentageChange }) => {
  const { user } = useContext(AuthContext);
  const [userId, setUserId] = useState(null);
  const [courierItem, setCourierItem] = useState({});
  const [submitError, setSubmitError] = useState(null);
  const [profileImage, setProfileImage] = useState("");
  const [cropImage, setCropImage] = useState(null);
  const [isCropModalOpen, setIsCropModalOpen] = useState(false);
  const cropperRef = useRef(null);
  const [uploadedImageUrl, setUploadedImageUrl] = useState(null);
  const [imageSmall1, setImageSmall1] = useState(null);
  const [imageSmall2, setImageSmall2] = useState(null);
  const [imageSmall3, setImageSmall3] = useState(null);
  const [imageSmall4, setImageSmall4] = useState(null);
  const [modalOpen1, setModalOpen1] = useState(false);
  const [fileNumber, setFileNumber] = useState(0);
  const [key, setKey] = useState(1);
  const [workingDaysData, setWorkingDaysData] = useState({});
  const [workingDaysData1, setWorkingDaysData1] = useState({});
  useEffect(() => {
    if (!user) {
      console.log("No user found in AuthContext");
      return;
    }
    console.log("User UID:", user.uid);
    setUserId(user.uid);

    const fetchCourierData = async () => {
      try {
        const response = await getCourierByUserId(user.uid);
        console.log("Courier data fetched:", response.data);
        setCourierItem(response.data.data || {});
        const courierData = response.data.data || {};
        setProfileImage(response.data.data?.profileImage || "");
        setImageSmall1(response.data.data?.image1 || boat1);
        setImageSmall2(response.data.data?.image2 || boat1);
        setImageSmall3(response.data.data?.image3 || boat1);
        setImageSmall4(response.data.data?.image4 || boat1);
        const workingHours = courierData.workingHours
          ? { ...courierData.workingHours } // Deep copy to avoid reference issues
          : {};
        setWorkingDaysData1(workingHours);
        console.log("Working Days Data 111:", workingDaysData);
      } catch (error) {
        console.error("Error fetching courier data:", error);
      }
    };

    fetchCourierData();
  }, [user]);

  // Add a separate useEffect to log workingDaysData changes
  useEffect(() => {
    console.log("Working Days Data1 Updated:", workingDaysData1);
  }, [workingDaysData1]);
  const handleWorkingHoursChange = (data) => {
    setWorkingDaysData(data);
    console.log("Updated Working Hours:", data);
  };

  const initialValues = {
    userId: userId || "",
    companyName: courierItem.companyName || "",
    employeeCount: courierItem.employeeCount || "",
    location: courierItem.location || "",
    email: courierItem.email || "",
    website: courierItem.website || "",
    establishedYear: courierItem.establishedYear || "",
    aboutCompany: courierItem.aboutCompany || "",
    lon: courierItem.lon || "",
    lat: courierItem.lat || "",
    profileImage: courierItem.profileImage || "",
    enableTwoStepVerification: courierItem.enableTwoStepVerification || false,
    workingHours: workingDaysData,
  };

  const countryList = [
    "Sri Lanka",
    "United States",
    "Canada",
    "United Kingdom",
    "Australia",
    "India",
    "Germany",
    "France",
    "China",
    "Japan",
  ];

  const images = [
    imageSmall1 || boat1,
    imageSmall2 || boat1,
    imageSmall3 || boat1,
    imageSmall4 || boat1,
  ];
  const imageSetters = {
    1: setImageSmall1,
    2: setImageSmall2,
    3: setImageSmall3,
    4: setImageSmall4,
  };

  const onImageUpload1 = (url) => {
    console.log("Image uploaded to:", url);
    setUploadedImageUrl(url);
  };

  const refreshComponent = async () => {
    // const response = await getVesselsByOwner(userId);
    // setAllVessels(response.data || []);

    // const response1 = await getVessel(vessel);
    // const vessel1 = response1.data || [];

    // setImageSmall1(vessel1.Image_Small1);
    // setImageSmall2(vessel1.Image_Small2);
    // setImageSmall3(vessel1.Image_Small3);
    // setImageSmall4(vessel1.Image_Small4);
    setKey((prev) => prev + 1);
  };

  const toggleCropModal = () => setIsCropModalOpen(!isCropModalOpen);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setCropImage(reader.result);
        toggleCropModal();
      };
      reader.readAsDataURL(file);
    }
  };

  const handleCrop = () => {
    const cropper = cropperRef.current?.cropper;
    if (cropper) {
      const croppedCanvas = cropper.getCroppedCanvas({
        width: 300,
        height: 300,
      });
      const compressedDataUrl = croppedCanvas.toDataURL("image/jpeg", 0.7);
      setProfileImage(compressedDataUrl);
      toggleCropModal();
    }
  };

  const validationSchema = Yup.object({
    userId: Yup.string().required("User ID is required"),
    companyName: Yup.string().required("Company Name is required"),
    employeeCount: Yup.number()
      .typeError("Must be a number")
      .positive("Must be positive")
      .integer("Must be an integer")
      .required("Number of employees is required"),
    location: Yup.string().required("Location is required"),
    email: Yup.string()
      .email("Invalid email format")
      .required("Email is required"),
    website: Yup.string().url("Invalid URL format").nullable(),
    establishedYear: Yup.number()
      .typeError("Must be a number")
      .positive("Must be a valid year")
      .integer("Must be a valid year")
      .required("Established year is required"),
    aboutCompany: Yup.string().required("About company is required"),
    lon: Yup.number()
      .typeError("Must be a number")
      .required("Longitude is required"),
    lat: Yup.number()
      .typeError("Must be a number")
      .required("Latitude is required"),
    enableTwoStepVerification: Yup.boolean(),
    workingHours: Yup.object(),
  });

  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (values, { setSubmitting }) => {
    if (!userId) {
      Swal.fire("Error!", "User not authenticated.", "error");
      setSubmitting(false);
      return;
    }
    console.log("handleSubmit called with values:", values);
    setSubmitError(null);
    try {
      const submissionData = {
        ...values,
        profileImage,
        userId: userId || values.userId,
      };
      console.log("Submitting data:", submissionData);
      const response = await apiClient.post("/v1/couriers/", submissionData);

      console.log("Form submitted successfully:", response.data);
      setSubmitted(true);
      Swal.fire("Success!", "Profile saved successfully.", "success");
      setTimeout(() => setSubmitted(false), 2000);
    } catch (error) {
      console.error("Submission error:", error);
      setSubmitError(
        error.response?.data?.message ||
          "Failed to submit form. Please try again."
      );
      Swal.fire(
        "Error!",
        error.response?.data?.message || "Failed to submit form.",
        "error"
      );
    } finally {
      setSubmitting(false);
    }
  };

  const calculateCompletionPercentage = (errors, values) => {
    const totalFields = 10; // Updated to include enableTwoStepVerification
    const fieldsToCheck = [
      "companyName",
      "employeeCount",
      "location",
      "email",
      "website",
      "establishedYear",
      "aboutCompany",
      "lon",
      "lat",
      "enableTwoStepVerification",
    ];

    let validFields = 0;

    fieldsToCheck.forEach((field) => {
      const fieldValue = values[field];
      const fieldError = errors[field];

      if (fieldValue && !fieldError) {
        validFields++;
      } else if (field === "enableTwoStepVerification" && !fieldError) {
        validFields++; // Count checkbox as valid even if false
      }
    });

    const percentage = Math.round((validFields / totalFields) * 100);
    console.log("Completion percentage:", percentage);
    if (onPercentageChange) {
      onPercentageChange(percentage);
    }
    return percentage;
  };

  return (
    <React.Fragment>
      <TabPane tabId="2">
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({ errors, touched, values, isSubmitting, handleSubmit }) => (
            <Form
              onSubmit={(e) => {
                e.preventDefault();
                handleSubmit(e);
              }}
            >
              {submitError && (
                <div className="alert alert-danger">{submitError}</div>
              )}
              <Row className="mb-3 p-4" style={{ display: "none" }}>
                <Col lg={6}></Col>
                <Col lg={6} className="text-end">
                  <p className="fs-14">
                    Completion: {calculateCompletionPercentage(errors, values)}%
                  </p>
                </Col>
              </Row>

              <Field name="userId" type="hidden" value={userId || ""} />

              <Row className="mb-3">
                <Col lg={12}>
                  <FormGroup>
                    <Label htmlFor="companyName">Company Name</Label>
                    <Field
                      name="companyName"
                      type="text"
                      className={`form-control ${
                        errors.companyName && touched.companyName
                          ? "is-invalid"
                          : ""
                      }`}
                    />
                    <ErrorMessage
                      name="companyName"
                      component="div"
                      className="invalid-feedback"
                    />
                  </FormGroup>
                </Col>
                <Col lg={6}>
                  <FormGroup>
                    <Label htmlFor="employeeCount">Employee Count</Label>
                    <Field
                      name="employeeCount"
                      type="number"
                      className={`form-control ${
                        errors.employeeCount && touched.employeeCount
                          ? "is-invalid"
                          : ""
                      }`}
                    />
                    <ErrorMessage
                      name="employeeCount"
                      component="div"
                      className="invalid-feedback"
                    />
                  </FormGroup>
                </Col>
                <Col lg={6}>
                  <FormGroup>
                    <Label htmlFor="location">Location</Label>
                    <Field
                      name="location"
                      as="select"
                      className={`form-control ${
                        errors.location && touched.location ? "is-invalid" : ""
                      }`}
                    >
                      <option value="" disabled>
                        Select a country
                      </option>
                      {countryList.map((country, index) => (
                        <option key={index} value={country}>
                          {country}
                        </option>
                      ))}
                    </Field>
                    <ErrorMessage
                      name="location"
                      component="div"
                      className="invalid-feedback"
                    />
                  </FormGroup>
                </Col>
                <Col lg={6}>
                  <FormGroup>
                    <Label htmlFor="email">Email</Label>
                    <Field
                      name="email"
                      type="email"
                      className={`form-control ${
                        errors.email && touched.email ? "is-invalid" : ""
                      }`}
                    />
                    <ErrorMessage
                      name="email"
                      component="div"
                      className="invalid-feedback"
                    />
                  </FormGroup>
                </Col>
                <Col lg={6}>
                  <FormGroup>
                    <Label htmlFor="website">Website</Label>
                    <Field
                      name="website"
                      type="url"
                      className={`form-control ${
                        errors.website && touched.website ? "is-invalid" : ""
                      }`}
                    />
                    <ErrorMessage
                      name="website"
                      component="div"
                      className="invalid-feedback"
                    />
                  </FormGroup>
                </Col>
                <Col lg={6}>
                  <FormGroup>
                    <Label htmlFor="establishedYear">Established Year</Label>
                    <Field
                      name="establishedYear"
                      type="text"
                      className={`form-control ${
                        errors.establishedYear && touched.establishedYear
                          ? "is-invalid"
                          : ""
                      }`}
                    />
                    <ErrorMessage
                      name="establishedYear"
                      component="div"
                      className="invalid-feedback"
                    />
                  </FormGroup>
                </Col>
                <Col lg={12}>
                  <FormGroup>
                    <Label htmlFor="aboutCompany">About Company</Label>
                    <Field
                      name="aboutCompany"
                      as="textarea"
                      className={`form-control ${
                        errors.aboutCompany && touched.aboutCompany
                          ? "is-invalid"
                          : ""
                      }`}
                    />
                    <ErrorMessage
                      name="aboutCompany"
                      component="div"
                      className="invalid-feedback"
                    />
                  </FormGroup>
                </Col>
                <Col lg={6}>
                  <FormGroup>
                    <Label htmlFor="lon">Longitude</Label>
                    <Field
                      name="lon"
                      type="number"
                      className={`form-control ${
                        errors.lon && touched.lon ? "is-invalid" : ""
                      }`}
                    />
                    <ErrorMessage
                      name="lon"
                      component="div"
                      className="invalid-feedback"
                    />
                  </FormGroup>
                </Col>
                <Col lg={6}>
                  <FormGroup>
                    <Label htmlFor="lat">Latitude</Label>
                    <Field
                      name="lat"
                      type="number"
                      className={`form-control ${
                        errors.lat && touched.lat ? "is-invalid" : ""
                      }`}
                    />
                    <ErrorMessage
                      name="lat"
                      component="div"
                      className="invalid-feedback"
                    />
                  </FormGroup>
                </Col>
                <Col lg={12}>
                  <FormGroup>
                    <Label check>
                      <Field
                        name="enableTwoStepVerification"
                        type="checkbox"
                        className="form-check-input"
                      />{" "}
                      Enable Two-Step Verification
                    </Label>
                    <ErrorMessage
                      name="enableTwoStepVerification"
                      component="div"
                      className="invalid-feedback"
                    />
                  </FormGroup>
                </Col>
                <ImageCropModal4
                  isOpen={modalOpen1}
                  onClose={() => setModalOpen1(false)}
                  onUpload={onImageUpload1}
                  courierId={userId} // Pass the IMULA_Number to the modal
                  companyName={courierItem.companyName} // Pass the company name to the modal
                  fileNumber={fileNumber} // Pass the file number to the modal
                  setImage={imageSetters[fileNumber]}
                  refreshComponent={refreshComponent}
                />
                <ProcessingPlantGallery
                  images={images}
                  onCameraClick={(fileno) => {
                    console.log(fileno);
                    setFileNumber(fileno);
                    setModalOpen1(true);
                  }}
                />

                <WorkingDaysWidget
                  onChange={handleWorkingHoursChange}
                  initialWorkingHours={workingDaysData1}
                />
                <FormGroup className="d-flex align-items-center flex-wrap gap-3">
                  <div>
                    <Label
                      htmlFor="profileImage"
                      style={{
                        fontSize: "14px",
                        fontWeight: "400",
                        fontFamily: "poppins",
                        marginBottom: "8px",
                      }}
                    >
                      Profile Image
                    </Label>
                    <div className="custom-file-upload">
                      <Input
                        id="profileImage"
                        type="file"
                        accept="image/*"
                        onChange={handleFileChange}
                        style={{ display: "none" }}
                        aria-label="Upload profile image"
                      />
                      <Button
                        color="primary"
                        size="sm"
                        style={{
                          fontFamily: "poppins",
                          padding: "8px 16px",
                          borderRadius: "8px",
                          transition:
                            "background-color 0.3s ease, transform 0.2s ease",
                        }}
                        className="custom-upload-button"
                        onClick={() =>
                          document.getElementById("profileImage").click()
                        }
                      >
                        <i className="ri-upload-2-line me-2"></i> Upload Image
                      </Button>
                    </div>
                  </div>
                  {profileImage ? (
                    <div className="image-preview-container mt-2">
                      <img
                        src={profileImage}
                        alt="Profile Preview"
                        style={{
                          width: "100px",
                          height: "100px",
                          borderRadius: "50%",
                          objectFit: "cover",
                          border: "2px solid #e9ecef",
                          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                        }}
                      />
                    </div>
                  ) : (
                    <div
                      className="image-placeholder mt-2 d-flex align-items-center justify-content-center"
                      style={{
                        width: "100px",
                        height: "100px",
                        borderRadius: "50%",
                        backgroundColor: "#f1f3f5",
                        border: "2px dashed #ced4da",
                        color: "#6c757d",
                        fontFamily: "poppins",
                        fontSize: "14px",
                        textAlign: "center",
                      }}
                    >
                      No Image
                    </div>
                  )}
                </FormGroup>
              </Row>

              <div className="mt-4 text-end">
                <Button
                  type="submit"
                  color={submitted ? "success" : "primary"}
                  disabled={isSubmitting}
                  style={{ fontFamily: "poppins" }}
                >
                  {isSubmitting
                    ? "Saving..."
                    : submitted
                    ? "Saved"
                    : "Save Changes"}
                </Button>
              </div>
            </Form>
          )}
        </Formik>

        {/* Crop Modal */}
        <Modal isOpen={isCropModalOpen} toggle={toggleCropModal} centered>
          <ModalBody>
            <Cropper
              src={cropImage}
              style={{ height: 300, width: "100%" }}
              aspectRatio={1}
              guides={false}
              ref={cropperRef}
            />
          </ModalBody>
          <ModalFooter>
            <Button
              color="primary"
              onClick={handleCrop}
              style={{ fontFamily: "poppins" }}
            >
              Crop & Save
            </Button>
            <Button
              color="secondary"
              onClick={toggleCropModal}
              style={{ fontFamily: "poppins" }}
            >
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
      </TabPane>
    </React.Fragment>
  );
};

export default CourierForm;
